import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import InfoIcon from '@material-ui/icons/Info';

import {
    Appointments,   
} from '@devexpress/dx-react-scheduler-material-ui';

const useStyles = makeStyles(theme => ({
    button: {
      color: theme.palette.background.default,
      padding: 0,
    },
    infoWrapper: {
        padding: '0 8px',
        marginTop: '-3px',
        display: 'flex',
        overflow: 'hidden'
    },
    info: {
        color: 'white',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    streamerName: {
    }
}));

export default function AppointmentBase(props) {
    const {
        children,
        data,
        onClick,
        toggleVisibility,
        onAppointmentMetaChange,
        ...restProps
    } = props;

    const classes = useStyles();
 
    return (
        <Appointments.Appointment
            {...restProps}
            className='_appointment'
            onDoubleClick={event => null}
        >
        <>
            <IconButton
            className={classes.button}
            onClick={({ target }) => {
                toggleVisibility();
                onAppointmentMetaChange({ target: target.closest('button').parentElement.parentElement, data });
            }}
            >
            <InfoIcon fontSize="small" />
            </IconButton>

            {children}

            <div className={classes.infoWrapper}>
                <Typography variant="body2" gutterBottom className={classes.info}>
                    {data.streamer.name}
                </Typography>
            </div>
        </>
        </Appointments.Appointment>
  );
}